import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared.module';

// Modal Components
import { ContactModalComponent } from './contact-modal/contact-modal.component';
import { DataModalComponent } from './data-modal/data-modal.component';
import { DatasetDetailModalComponent } from './dataset-detail-modal/dataset-detail-modal.component';
import { ForgotPasswordModalComponent } from './forgot-password-modal/forgot-password-modal.component';
import { IncidentReportModalComponent } from './incident-report-modal/incident-report-modal.component';
import { LoginModalComponent } from './login-modal/login-modal.component';
import { SetupProfileModalComponent } from './setup-profile-modal/setup-profile-modal.component';
import { SignupModalComponent } from './signup-modal/signup-modal.component';
import { VerifyOtpModalComponent } from './verify-otp-modal/verify-otp-modal.component';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { PartnerFormModalComponent } from './partner-form-modal/partner-form-modal.component';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSpinModule } from 'ng-zorro-antd/spin';

const MODAL_COMPONENTS = [
    ContactModalComponent,
    DataModalComponent,
    DatasetDetailModalComponent,
    ForgotPasswordModalComponent,
    IncidentReportModalComponent,
    LoginModalComponent,
    SetupProfileModalComponent,
    SignupModalComponent,
    VerifyOtpModalComponent,
    ConfirmModalComponent,
    PartnerFormModalComponent,
];

@NgModule({
    declarations: [...MODAL_COMPONENTS],
    imports: [
        NzButtonModule,
        NzCheckboxModule,
        NzFormModule,
        NzInputModule,
        NzPaginationModule,
        NzSelectModule,
        NzSpinModule,
        RouterModule,
        SharedModule,
    ],
    exports: [...MODAL_COMPONENTS],
})
export class ModalsModule {}
